import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  TypographyProps,
  typography,
  SpaceProps,
  space,
  variant,
  border,
  BorderProps,
  BackgroundProps,
  background,
  ComponentsType
} from '@lucid/theme';
import { AccordionItemPanel } from 'react-accessible-accordion';

export interface AccordionPanelProps
  extends BackgroundProps,
  TypographyProps,
  SpaceProps,
  BorderProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The children to be rendered with the Accordion.Panel. */
  children?: ReactNode;
  /** The available variants for the `Accordion.Panel` component. */
  variant?: ComponentsType['Accordion']['Panel'];
}

const panelStyleProps = compose(background, typography, space, border);

const StyledAccordionPanel = styled(AccordionItemPanel)<AccordionPanelProps>(
  variant({
    scale: 'accordion.panel',
    variants: {
      defaultVariant: {}
    }
  }),
  {
    label: 'panel'
  },
  panelStyleProps
);

const AccordionPanel: FC<AccordionPanelProps> = ({ className, variant = 'default', ...rest }) => (
  <StyledAccordionPanel {...rest} className={className} variant={variant} />
);

export { AccordionPanel };
export default AccordionPanel;
